module.exports = __webpack_public_path__ + "media/SWV-I_DW_4_Dienes-Material.8a051d9a.mp3";